import { Grid, Typography } from "@mui/material";
import FormField from "../../../components/common/FormField";
import { LEAD_LOG_STARTER_FIELD, leadLogsFields } from "./leadAllFields";
import CustomButton from "../../../components/common/button/CustomButton";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Validation from "../../../utils/Validation";
import {
  addLeadLogAction,
  getSingleLeadAction,
  setAddLeadLogAction,
} from "../../../store/reducers/leadSlice";
import { useSelector } from "react-redux";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import dayjs from "dayjs";
import AlertLogs from "./AlertLogs";
import Notification from "../../../components/common/notification/Notification";
import { ARCHIEVED_REASON, PROFESSIONAL_ARCHIEVED, PROFESSIONAL_LOST, QUOTE_REASON, SURVEY_REASON } from "./logReasonList";

const statusToIndex: { [key: string]: number } = {
  NEW: 0,
  ESTIMATES: 1,
  SURVEY: 2,
  QUOTE: 3,
  CONFIRMED: 4,
  JOB: 5,
  COMPLETED: 6,
  Completed: 6,
};

interface ManageLogsProps {
  setLeadId?: any;
  leadId?: any;
}

const ManageLogs: React.FC<ManageLogsProps> = ({ leadId }) => {
  const dispatch = useDispatch();
  const { leadDetails, isAddLeadLogSuccess } = useSelector(
    (state: any) => state.lead
  );
  const {  userProfile } = useSelector((state: any) => state?.user);
  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
    userProfile?.features?.includes("Basic Work Diary") || false // Safe fallback
  );

  useEffect(() => {
    setIsBasicDiarySection(
      userProfile?.features?.includes("Basic Work Diary") || false
    ); // Sync profile changes
  }, [userProfile]);
  const [isActionCalled, setIsActionCalled] = useState(false);

  const [formData, setFormData] = useState<{ [key: string]: string | null }>({
    action: "",
    follow_up_date: null,
    action_type: "",
    specific_detail: "",
    status_change_reason: "",
  });

  const shouldValidateReason =
    formData?.action_type === "SURVEY" ||
    formData?.action_type === "QUOTE" ||
    formData?.action_type === "ARCHIVED";

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    action: formData?.action,
    //  status_change_reason: shouldValidateReason ? formData?.status_change_reason : undefined,
    // actionDate: formData?.actionDate,
    // actionName: formData?.actionName,
    // actionSpecific: formData?.actionSpecific,
  });

  const [alertModelShow, setAlertModelShow] = useState(false);

  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    setFormData({
      ...formData,
      [id]: value,
    });
    resetValidator(event.target.id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const [isValid, setIsValid] = useState(false);

  const isValidStageSequence = (newStage: string) => {
    const currentStageIndex = statusToIndex[leadDetails?.lead?.status ?? "NEW"];
    const newStageIndex = statusToIndex[newStage];
    // Allow only the next stage in the sequence (currentStageIndex + 1)
    return (
      newStageIndex === currentStageIndex ||
      newStageIndex === currentStageIndex + 1 ||
      newStageIndex === currentStageIndex - 1
    );
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        // Check if the stage selection is valid
        if (
          formData?.action_type &&
          !isValidStageSequence(formData?.action_type)
        ) {
          setAlertModelShow(true); // Show modal if skipped stages
        } else {
          setIsValid(true);
        }
      } else {
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (isValid) {
      dispatch(addLeadLogAction({ ...formData, leadId }));
    }
    setIsValid(false);
  }, [isValid]);

  useEffect(() => {
    if (isAddLeadLogSuccess) {
      setFormData({
        action: "",
        follow_up_date: null,
        action_type: "",
        specific_detail: "",
        status_change_reason: "",
      });
      resetAllValidator();
      dispatch(getSingleLeadAction(leadId));
      dispatch(setAddLeadLogAction(false));
      setAlertModelShow(false);
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  }, [isAddLeadLogSuccess]);

  useEffect(() => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setFormData({
      action: "",
      follow_up_date: null,
      action_type: "",
      specific_detail: "",
      status_change_reason: "",
    });
    resetAllValidator();
  }, [leadId]);

  const onClose = () => {
    setAlertModelShow(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  // Set county dropdown options based on country
  const getReasonOptions = (action_type: any) => {
    return action_type === "ARCHIVED"
      ? PROFESSIONAL_ARCHIEVED
      : action_type === "SURVEY"
      ? SURVEY_REASON
      : action_type === "QUOTE"
      ? QUOTE_REASON 
      : action_type ==='LOST' ?
      PROFESSIONAL_LOST
      : [];
  };

  const FORM_FIELD = isBasicDiarySection
    ? leadLogsFields
    : LEAD_LOG_STARTER_FIELD;

  return (
    <>
      <Notification />
      <AlertLogs
        open={alertModelShow}
        setAlertModelShow={setAlertModelShow}
        setIsValid={setIsValid}
        onHide={onClose}
      />
      <Grid
        container
        spacing={2}
        sx={{
          // background: "#d3d3d3",
          margin: "0px",
          border: "2px solid #EAE9EA",
          
        }}
      >
        {FORM_FIELD?.map((field, i) => {
          return (
            <>
              <Grid item key={i} md={field?.md}>
                {field?.title && (
                  <Typography sx={{ fontWeight: 600,color:'#637381' }}>
                    {field?.title}{" "}
                    {field?.isMandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </Typography>
                )}
                <FormField
                  // onPaste={(e: any) => e.preventDefault()}
                  onKeyDown={(event: any) => {
                    if (
                      [8, 9, 37, 38, 39, 40, 18, 17].includes(event.keyCode) ||
                      event.ctrlKey
                    )
                      return event;
                  
                  }}
                  {...{
                    ...field,
                    value: formData[field?.id] ?? "",
                    options:
                      field.id === "status_change_reason"
                        ? getReasonOptions(formData?.action_type)
                        : field.options,
                    variant: "outlined", // Adding this variant prop
                    onChange: onChangeAction,
                    onBlur: onBlurAction,
                    isNonMarginTop: true,
                    minDate:
                      field.id === "follow_up_date"
                        ? dayjs().add(1, "day").toDate()
                        : undefined,
                    disabled:
                      field?.id === "status_change_reason"
                        ? formData?.action_type === "SURVEY" ||
                          formData?.action_type === "QUOTE" ||
                          formData?.action_type === "ARCHIVED" ||
                          formData?.action_type ==="LOST"
                          ? false
                          : true
                        : leadId
                        ? false
                        : true,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px", padding: "0px 4px" }
                          : { padding: "10px 4px", height: "36px" },
                    },

                    error: error && error[field?.id],
                  }}
                />
              </Grid>
            </>
          );
        })}
        <Grid
          item
          sm={1}
          md={isBasicDiarySection ? 3 : 2}
          sx={{
            position: "relative",
          }}
        >
          <CustomButton
            disabled={leadId ? false : true}
            style={{ padding: "10px 56px", height: "36px",marginTop: "23px",position:'absolute',right:'10px' }}
            title="Add"
            variant="outlined"
            onClick={handleSubmit}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default ManageLogs;
